import axios, { buildApi } from '@/libs/api.request';
import {getToken} from "@/libs/util";

export const uploadAttachment = (data) => {
  return axios.request({
    url: `/common/uploadAttachment`,
    method: 'POST',
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
  })
}

export const getInvoiceTypes = () => {
  return axios.request({
    url: `/common/invoiceTypes`,
    method: 'GET',
  })
}

export const getInvoiceArray = (data) => {
  return axios.request({
    url: `/common/invoice/` + data,
    method: 'GET',
  })
}

export const removeInvoice = ({domId, id}) => {
  return axios.request({
    url: `/common/invoice/` + id + '?domID=' + domId,
    method: 'DELETE',
  })
}
